"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var PersonalPromoCodesListCtl = /** @class */ (function (_super) {
    __extends(PersonalPromoCodesListCtl, _super);
    function PersonalPromoCodesListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.title; });
        _this.dk_brand_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_id; });
        _this.dk_brand_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_title; });
        _this.dk_promocode_template_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.promocode_template_id; });
        _this.dk_promocode_template_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.promocode_template_title; });
        _this.dk_description = UIUtils_1.UIUtils.IProp2Str(function (o) { o.description; });
        _this.dk_is_locked = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_locked; });
        _this.dk_handling_type_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.handling_type_code; });
        _this.dk_handling_type_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.handling_type_title; });
        _this.dk_date_added = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added; });
        _this.dk_date_changed = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed; });
        _this._errDialog = errDialog;
        return _this;
    }
    PersonalPromoCodesListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0
        };
    };
    PersonalPromoCodesListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "jackpot locale with id [" + id + "] not found !";
    };
    PersonalPromoCodesListCtl.prototype.LoadData = function (AllBrands, BrandIdList, onDone) {
        var _this = this;
        webAApi_1.ListPersonalPromoCodeOffersByBrandIdGet.exec({
            all_brands: AllBrands,
            brand_id_list: BrandIdList
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    title: resp.list[i].title,
                    brand_id: resp.list[i].brand_id,
                    brand_title: resp.list[i].brand_title,
                    description: resp.list[i].description,
                    is_locked: resp.list[i].is_locked,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    promocode_template_id: resp.list[i].promocode_template_id,
                    promocode_template_title: resp.list[i].promocode_template_title,
                    handling_type_code: resp.list[i].handling_type_code,
                    handling_type_title: resp.list[i].handling_type_title
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    PersonalPromoCodesListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddPersonalPromoCodeOffer.exec({
            data: {
                brand_id: data.brand_id,
                promocode_template_id: data.promocode_template_id,
                title: data.title,
                description: data.description,
                handling_type_code: data.handling_type_code,
                is_locked: data.is_locked
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                date_changed: moment(resp.date_changed_uts_ms).utc(false),
                date_added: moment(resp.date_added_uts_ms).utc(false),
                brand_id: data.brand_id,
                brand_title: resp.brand_title,
                title: data.title,
                description: data.description,
                is_locked: data.is_locked,
                handling_type_code: data.handling_type_code,
                handling_type_title: resp.handling_type_title,
                promocode_template_id: data.promocode_template_id,
                promocode_template_title: resp.promocode_template_title
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    PersonalPromoCodesListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditPersonalPromoCodeOffer.exec({
                data: {
                    personal_promocode_offer_id: data.key,
                    title: data.title,
                    handling_type_code: data.handling_type_code,
                    description: data.description,
                    is_locked: data.is_locked
                }
            }, function (resp) {
                _tmp.title = data.title;
                _tmp.handling_type_code = data.handling_type_code;
                _tmp.handling_type_title = resp.handling_type_title;
                _tmp.description = data.description;
                _tmp.is_locked = data.is_locked;
                _tmp.date_changed = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    PersonalPromoCodesListCtl.prototype.RemoveItem = function (key) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === key) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    PersonalPromoCodesListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeletePersonalPromoCodeOffer.exec({ data: { personal_promocode_offer_id: key } }, function (resp) {
                _this.RemoveItem(key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    PersonalPromoCodesListCtl.prototype.DoSetIsLocked = function (key, IsLocked, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetPersonalPromoCodeOfferIsLocked.exec({ data: { personal_promocode_offer_id: key, is_locked: IsLocked } }, function (resp) {
                _tmp.is_locked = IsLocked;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return PersonalPromoCodesListCtl;
}(BaseController_1.BaseController));
exports.PersonalPromoCodesListCtl = PersonalPromoCodesListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_personal/ctl/PersonalPromoCodesListCtl.ts
// module id = 1062
// module chunks = 0